import { createTheme } from "@mui/material/styles";

export const brand = {
  navy: "#0B1220",
  navyDeep: "#070C18",
  blue: "#2563EB",
  blueSoft: "#3B82F6",
  textOnDark: "#E5E7EB",
  textMutedOnDark: "#94A3B8",
};

export const theme = createTheme({
  palette: {
    mode: "light",
    primary: { main: brand.blue, dark: "#1D4ED8", contrastText: "#FFFFFF" },
    secondary: { main: brand.navy },
    background: { default: "#F1F5F9", paper: "#FFFFFF" },
    success: { main: "#16A34A" },
    warning: { main: "#D97706" },
    error: { main: "#DC2626" },
    text: { primary: "#0F172A", secondary: "#475569" },
  },
  shape: { borderRadius: 14 },
  typography: {
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      "'Segoe UI'",
      "Roboto",
      "'Helvetica Neue'",
      "Arial",
      "sans-serif",
    ].join(","),
    h4: { fontWeight: 700, letterSpacing: "-0.01em" },
    h6: { fontWeight: 600 },
    button: { fontWeight: 600, textTransform: "none" },
  },
  components: {
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: { borderRadius: 10, paddingInline: 18 },
        containedPrimary: {
          background: `linear-gradient(135deg, ${brand.blue} 0%, ${brand.blueSoft} 100%)`,
          "&:hover": {
            background: `linear-gradient(135deg, #1D4ED8 0%, ${brand.blue} 100%)`,
          },
        },
      },
    },
    MuiTextField: { defaultProps: { size: "small", fullWidth: true } },
    MuiPaper: {
      styleOverrides: {
        root: { backgroundImage: "none" },
      },
    },
  },
});
